import Layout from '@/layout';

const allianceRouter = {
  path: '/alliance',
  component: Layout,
  redirect: '/alliance/overview',
  name: 'Alliance',
  meta: {
    title: '联盟管理',
    icon: 'peoples',
  },
  children: [
    {
      path: 'overview',
      name: 'AllianceOverview',
      component: () => import('@/views/alliance/overview/index'),
      meta: {
        title: '联盟概览',
        icon: 'dashboard',
        perms: ['merchant:alliance:info'],
      },
    },
    {
      path: 'orderTaker',
      name: 'AllianceOrderTaker',
      component: () => import('@/views/alliance/orderTaker/index'),
      meta: {
        title: '带单员档案',
        perms: ['merchant:alliance:order:taker:list'],
      },
    },
    {
      path: 'reward',
      name: 'AllianceReward',
      component: () => import('@/views/alliance/reward/index'),
      meta: {
        title: '带单奖励',
        perms: ['merchant:alliance:reward:list'],
      },
    },
    {
      path: 'allocation',
      name: 'AllianceAllocation',
      component: () => import('@/views/alliance/allocation/index'),
      meta: {
        title: '支付分账模板',
        perms: ['merchant:alliance:allocation:list'],
      },
    },
    {
      path: 'dealRegister',
      name: 'AllianceDealRegister',
      component: () => import('@/views/alliance/dealRegister/index'),
      meta: {
        title: '带单登记审核',
        perms: ['merchant:alliance:deal:register:list'],
      },
    },
  ],
};

export default allianceRouter;
